import { createSlice } from "@reduxjs/toolkit";
import { editBookingAPI } from "../../api/cloneBooking";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const editBookingSlice = createSlice({
  name: "editBooking",
  initialState: data,
  reducers: {
   editBookingSlice(state) {
      state.isLoading = true;
    },
   editBookingSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    editBookingSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    editBookingSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const editBookingHandler = (id:any,data:any) => async (dispatch: any) => {
  try {
    dispatch(editBookingAction.editBookingSlice());
    const response: any = await editBookingAPI(id,data);
    
    dispatch(editBookingAction.editBookingSliceSuccess(response));
  } catch (e: any) {
    dispatch(editBookingAction.editBookingSliceFailure(e?.response?.data));
  }
};
export default editBookingSlice.reducer;
export const editBookingAction = editBookingSlice.actions;
